import React from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";

// MUI //
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Menu,
  MenuItem,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import AssessmentIcon from "@mui/icons-material/Assessment";
import DonutSmallIcon from "@mui/icons-material/DonutSmall";
import MenuIcon from "@mui/icons-material/Menu";

// Components, Variables //
import SkipToMain from "./SkipToMain";
import { basicBlueVariable, basicDisabledGrey } from "../utils/appStyles";

const NavBar: React.FC = () => {
  const location = useLocation();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const isActive = (path: string): boolean => {
    return location.pathname === path;
  };

  return (
    <>
      <SkipToMain mainId={"home-main"} />
      <AppBar position="static" sx={{ boxShadow: "none" }}>
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: basicBlueVariable,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 0.5,
            }}
          >
            <Typography variant="body1">Financetracker.app</Typography>
            <DonutSmallIcon />
          </Box>

          <Box sx={{ display: "flex", gap: 2 }}>
            <Button
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
            >
              <MenuIcon sx={{ color: "white" }} />
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem
                onClick={handleClose}
                component={RouterLink}
                to="/"
                sx={{ color: isActive("/") ? basicDisabledGrey : "" }}
              >
                <HomeIcon />
                <Typography>Home</Typography>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={RouterLink}
                to="/report"
                sx={{
                  color: isActive("/report") ? basicDisabledGrey : "",
                }}
              >
                <AssessmentIcon />
                <Typography>Report</Typography>
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default NavBar;
